import axios from '@/api/axios'

const BASE_URL = 'go/org-api-config'

function mapApiConfig (item) {
  if (!item) return null
  return {
    id: item.id || null,
    name: item.name || '',
    api_key: item.api_key || '',
    updated_at: item.updated_at || ''
  }
}

function mapCustomerWithConfig (item) {
  return {
    id: item?.provider?.id || null,
    name: item?.provider?.name || '',
    code: item?.provider?.code || '',
    api_config: mapApiConfig(item?.config)
  }
}

function getPayloadData (response) {
  return response?.data?.data
}

class OrgIntegrationApiKeyService {
  async getOrgConfigs ({ orgId }) {
    if (!orgId) return []
    const response = await axios.get(BASE_URL, {
      params: {
        org_id: orgId
      }
    })
    const list = Array.isArray(getPayloadData(response)) ? getPayloadData(response) : []
    return list.map(mapCustomerWithConfig)
  }

  async getCustomersWithApiConfig ({ orgId }) {
    return this.getOrgConfigs({ orgId })
  }

  async createApiConfig ({ orgId, providerApiServiceId, name, apiKey }) {
    const response = await axios.post(BASE_URL, {
      org_id: orgId,
      provider_api_service_id: providerApiServiceId,
      name,
      api_key: apiKey
    })
    return mapApiConfig(getPayloadData(response))
  }

  async updateApiConfig ({ id, name, apiKey }) {
    const response = await axios.put(`${BASE_URL}/${id}`, {
      name,
      api_key: apiKey
    })
    return mapApiConfig(getPayloadData(response))
  }

  async saveCustomerApiKey ({ orgId, customerId, configId, name, apiKey }) {
    if (configId) {
      return this.updateApiConfig({
        id: configId,
        name,
        apiKey
      })
    }
    return this.createApiConfig({
      orgId,
      providerApiServiceId: customerId,
      name,
      apiKey
    })
  }

  async deleteApiConfig ({ id }) {
    await axios.delete(`${BASE_URL}/${id}`)
    return true
  }

  async deleteCustomerApiKey ({ configId }) {
    if (!configId) return false
    return this.deleteApiConfig({ id: configId })
  }
}

export default new OrgIntegrationApiKeyService()
